import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as MenuAction from './MenuAction';
import * as $ from 'jquery';
const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};

//WW - 1216 Precart - Yuvarani K
const RatingSubmission = (RatingBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ItemDetailNew,
            SDIConstants.methodNames.InsertReview,
            JSON.stringify(RatingBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "RatingSubmissionresponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

const GetpageLoad = (GetSearchBO) => {
    try {
       
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_Page_Load,
            JSON.stringify(GetSearchBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "TsSearchresult", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const AddCart = (AddCartBO) => {
    try {
      
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_AddToCart_Click,
            JSON.stringify(AddCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SupplierStatus", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};


const catfavItem = (catfavItemBO) => {
    try {
        //debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_InsertFavItem,
            JSON.stringify(catfavItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FavitemAdd", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

//WW-1216 Precart - Yuvarani K
const NoncatfavItem = (NoncatfavItemBO) => {
    try {
        //debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_AddNonCatalogFavItem,
            JSON.stringify(NoncatfavItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FavitemAdd", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

//WW-1216 Precart - Yuvarani K
const DeletFavItem = (deleteFavBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_DeleteFavItem,
            JSON.stringify(deleteFavBO),

            (data) => {
                if (data.success) {
                    //debugger;
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.FavItemMaintenance_DeleteFavItem, response: data.response };
                        //debugger;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}




                    
//[12/15/22], PC_WW-552_FE_5, Dhevanesam R
const dynamicFormData = (dynamicFormBO) => {
    try {
     
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_dynamicFormClick,
            JSON.stringify(dynamicFormBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "DynamicForm", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

//WW - 1216 Precart - Yuvarani K

export { GetpageLoad, AddCart, dynamicFormData, RatingSubmission, DeletFavItem, NoncatfavItem, catfavItem }